<template>
	<div v-if="skus" class="texto--text">
		<template v-if="cores.length > 0">
			<div class="mb-1"><strong>Cor:</strong> {{ sku.cor }}</div>
			<ul class="produto__cores">
				<template v-for="(sku, i) in cores">
					<li :key="i">
						<button class="produto__botao-cor" @click="selecionarSku(sku, 'cor')">
							<img
								v-if="sku.skuimagens[0]"
								:src="sku.skuimagens[0].url_img"
								class="produto__cor"
								:class="contornarCorSelecionada(sku)"
							/>
							<img
								v-else
								src="@/assets/produto.png"
								class="produto__cor"
								:class="contornarCorSelecionada(sku)"
							/>
						</button>
					</li>
				</template>
			</ul>
		</template>
		<template v-if="tamanhos.length > 0">
			<div class="mb-1"><strong>Tamanho:</strong></div>
			<ul class="produto__tamanhos">
				<template v-for="(sku, i) in tamanhos">
					<li :key="i">
						<button
							:key="i"
							class="produto__tamanho"
							:class="contornarTamanhoSelecionado(sku)"
							@click="selecionarSku(sku, 'tamanho')"
						>
							{{ sku.tamanho.toUpperCase() }}
						</button>
					</li>
				</template>
			</ul>
		</template>
		<template v-if="voltagens.length > 0">
			<div class="mb-1"><strong>Voltagem:</strong></div>
			<ul class="produto__voltagens">
				<template v-for="(sku, i) in voltagens">
					<li :key="i">
						<button
							:key="i"
							class="produto__voltagem"
							:class="contornarVoltagemSelecionada(sku)"
							@click="selecionarSku(sku, 'voltagem')"
						>
							{{ sku.voltagem.toUpperCase() }}
						</button>
					</li>
				</template>
			</ul>
		</template>
		<template v-if="sabores.length > 0">
			<div class="mb-1"><strong>Sabor: </strong>{{ sku.sabor }}</div>
			<ul class="produto__cores">
				<template v-for="(sku, i) in sabores">
					<li :key="i">
						<button class="produto__botao-cor" @click="selecionarSku(sku, 'sabor')">
							<img
								v-if="sku.skuimagens[0]"
								:src="sku.skuimagens[0].url_img"
								class="produto__cor"
								:class="contornarSaborSelecionado(sku)"
							/>
							<img
								v-else
								src="@/assets/produto.png"
								class="produto__cor"
								:class="contornarSaborSelecionado(sku)"
							/>
						</button>
					</li>
				</template>
			</ul>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		skus: Array,
		skuSelecionado: Object,
	},
	components: {},
	data: function () {
		return {
			sku: this.skuSelecionado,
			tipos: ['cor', 'tamanho', 'voltagem', 'sabor'],
		}
	},
	computed: {
		cores() {
			let cores = this.skus.filter((cor) => cor.cor)
			return cores.filter((value, index, self) => self.map((x) => x.cor).indexOf(value.cor) == index)
		},
		tamanhos() {
			const tamanhos = this.skus.filter((tamanho) => tamanho.cor == this.sku.cor && tamanho.tamanho)
			return tamanhos.filter((value, index, self) => self.map((x) => x.tamanho).indexOf(value.tamanho) == index).sort(function(a, b){return a.tamanho-b.tamanho})
		},
		voltagens() {
			const voltagens = this.skus.filter(
				(voltagem) => voltagem.cor == this.sku.cor && voltagem.tamanho == this.sku.tamanho && voltagem.voltagem
			)

			if (voltagens.length > 0 && this.sku.voltagem == '') this.selecionarSku(voltagens[0], 'voltagem')
			return voltagens.filter(
				(value, index, self) => self.map((x) => x.voltagem).indexOf(value.voltagem) == index
			)
		},
		sabores() {
			let sabores = this.skus.filter(
				(sabor) =>
					sabor.cor == this.sku.cor &&
					sabor.tamanho == this.sku.tamanho &&
					sabor.voltagem == this.sku.voltagem &&
					sabor.sabor
			)

			sabores.map((sabor) => {
				if (sabor.skuimagens.length < 1) {
					sabor.skuimagens = this.encontrarImagens(sabor, 'sabor')
				}
			})

			if (sabores.length > 0 && this.sku.sabor == '') this.selecionarSku(sabores[0], 'sabor')

			return sabores.filter((value, index, self) => self.map((x) => x.sabor).indexOf(value.sabor) == index)
		},
	},
	methods: {
		selecionarSku(sku, tipo) {
			this.sku = sku
			if (!this.sku.skuimagens || this.sku.skuimagens.length == 0)
				this.sku.skuimagens = this.encontrarImagens(sku, tipo)
			this.$emit('selecionarSku', sku)
		},
		contornarCorSelecionada(sku) {
			if (this.sku.cor == sku.cor) return 'produto__cor--selecionado'
		},
		contornarTamanhoSelecionado(sku) {
			if (this.sku.tamanho == sku.tamanho) return 'produto__tamanho--selecionado'
		},
		contornarVoltagemSelecionada(sku) {
			if (this.sku.voltagem == sku.voltagem) return 'produto__voltagem--selecionada'
		},
		contornarSaborSelecionado(sku) {
			if (this.sku.sabor == sku.sabor) return 'produto__sabor--selecionado'
		},
		contornarBulletSelecionado(i) {
			if (i == this.contadorImagem) return 'produto__paginacao-bullet--selecionado'
		},
		encontrarImagens(sku, tipo) {
			const contador = this.tipos.indexOf(tipo)

			let imagens

			for (var i = contador; i > 0; i--) {
				if (i == 3) {
					imagens = this.voltagens.filter(
						(el) => el.cor == sku.cor && el.tamanho == sku.tamanho && sku.voltagem == el.voltagem
					)[0]
				}

				if (!imagens && i == 2) {
					imagens = this.tamanhos.filter((el) => el.cor == sku.cor && el.tamanho == sku.tamanho)[0]
				}

				if (!imagens && i == 1) {
					imagens = this.cores.filter((el) => el.cor == sku.cor)[0]
				}
			}

			return imagens ? imagens.skuimagens : [{ url_img: require(`@/assets/produto.png`) }]
		},
	},
}
</script>

<style scoped>
ul,
li {
	list-style-type: none;
	margin: 0;
	padding: 0;
}
.produto__cores {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 20px;
}

.produto__botao-cor {
	display: block;
	width: 73px;
	height: 73px;
	border-radius: 13px;
	margin: 0;
}

.produto__botao-cor:focus {
	outline-color: var(--v-primary-base);
}

.produto__cor {
	width: 73px;
	height: 73px;
	border-radius: 13px;
	margin: 0 auto;
	cursor: pointer;
	object-fit: cover;
	aspect-ratio: 1 / 1;
}

.produto__cor:not(.produto__cor--selecionado):hover {
	border: 2px solid var(--v-primary-base);
	padding: 2px;
}

.produto__cor--selecionado,
.produto__sabor--selecionado {
	border: 3px solid var(--v-primary-base);
}

.produto__tamanhos {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 20px;
}

.produto__tamanho {
	margin: 0;
	width: 32px;
	height: 32px;
	text-align: center;
	line-height: 31.86px;
	border-radius: 20px;
	text-decoration: none;
	outline: none;
}

.produto__tamanho:not(.produto__tamanho--selecionado):hover,
.produto__tamanho:not(.produto__tamanho--selecionado):focus {
	background-color: var(--v-primary-base);
	opacity: 40%;
	color: white;
}

.produto__tamanho--selecionado {
	color: white;
	background-color:var(--v-primary-base);
}

.produto__voltagens {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 20px;
}

.produto__voltagem {
	margin: 0;
	text-align: center;
	border-radius: 13px;
	padding: 5px;
	text-decoration: none;
	outline: none;
}

.produto__voltagem:not(.produto__voltagem--selecionada):hover,
.produto__voltagem:not(.produto__voltagem--selecionada):focus {
	background-color: var(--v-primary-base);
	opacity: 40%;
	color: white;
}

.produto__voltagem--selecionada {
	color: white;
	background-color: var(--v-primary-base);
}
</style>